import {isEmpty} from 'lodash'
import {accountHasFeature, userHasPermission} from 'helpers/user'
import {features, permissions} from 'helpers/constants'

export const isMailchimpEnabled = (user) => {
  return (
      accountHasFeature(user, features.MAILCHIMP_SYNC)
  )
}

export const isPostToMailchimpEnabled = (user, isMailchimpConnected) => {
  return (
      isMailchimpConnected &&
      isMailchimpEnabled(user) &&
      userHasPermission(user, permissions.POST_CONTACTS)
  )
}

export const getDefaultListId = (lists) => {
  if (isEmpty(lists))
    return null

  return lists[0].id
}

export const MailChimpMergeFieldTag = {
  FNAME: 'FNAME',
  LNAME: 'LNAME',
  CNAME: 'CNAME',
  ADDRESS: 'ADDRESS',
  PHONE: 'PHONE',
}

export const getMergeFieldsParams = (mergeFieldValues) => {
  const params = {}
  mergeFieldValues.forEach(mergeFieldValue => {
    params[mergeFieldValue.tag] = mergeFieldValue.value
  })
  return params
}
